module.exports = __webpack_public_path__ + "img/box_tit_style_1.9fa411bd.png";